/**
 * 🆕 [Phase 86 Sprint Parking 1.5 — 2026-06-23] Page fusionnée — redirect.
 *
 * L'ancienne page "Admin Parking" est désormais fusionnée avec `/parking` via
 * un toggle "Mode édition" Owner-only. Cette route reste pour rétrocompat des
 * bookmarks existants : elle redirige vers `/parking?mode_edition=true`
 * (qui active automatiquement le toggle au chargement et nettoie l'URL).
 */
import { Navigate } from 'react-router-dom';

export default function ParkingAdmin() {
  return <Navigate to="/parking?mode_edition=true" replace />;
}
